import { Outlet } from 'react-router';

import { RomAllRequestsRouteActions } from './RomAllRequestsRouteActions';
import { ToolbarAndContentLayout } from 'src/common/primitives/ToolbarAndContentLayout';
import { TripsNav } from 'src/features/trip/TripsNav';

export function RomAllRequestsLayout() {
  return (
    <ToolbarAndContentLayout
      preContent={<TripsNav />}
      actionSection={<RomAllRequestsRouteActions />}
      content={<Outlet />}
    />
  );
}
